export const GEO_DETAIL_FOLD_START_TOKEN = 'answer-geo-fold:details:start';
export const GEO_DETAIL_FOLD_END_TOKEN = 'answer-geo-fold:details:end';

export const GEO_DETAIL_FOLD_START = `<!-- ${GEO_DETAIL_FOLD_START_TOKEN} -->`;
export const GEO_DETAIL_FOLD_END = `<!-- ${GEO_DETAIL_FOLD_END_TOKEN} -->`;
